<template>
  <div :class="s.contentPublicity">
    <!-- 1. 智选保代宣传月 - 守住钱袋子·护好幸福家 -->
    <img
      :src="require('../../images/ic_supervision_publicity1.png')"
      @click="gotoDetail(1)"
      :class="[s.slice, s.clickable]"
    />
    <div/>
    <img
      :src="require('../../images/ic_supervision_publicity2.png')"
      @click="gotoDetail(2)"
      :class="[s.slice, s.clickable]"
    />

    <!-- 2. 保护个人信息谨防网络诈骗 -->
    <div :class="[s.slice, s.block]">
      <h3>保护个人信息谨防网络诈骗</h3>
      <img
        :src="require('../../images/ic_publicity3.jpeg')"
        @click="gotoDetail(3)"
      />
    </div>
    <div/>

    <!-- 3. 汇聚金融力量共创美好生活 -->
    <div :class="[s.slice, s.block]">
      <h3>汇聚金融力量共创美好生活</h3>
      <img
        :src="require('../../images/ic_publicity4.jpeg')"
        @click="gotoDetail(4)"
      />
    </div>

    <!-- 4. 金融消保在身边 保障权益防风险 -->
    <div :class="[s.slice, s.block]">
      <h3>金融消保在身边 保障权益防风险</h3>
      <img
        :src="require('../../images/ic_publicity5.jpeg')"
        @click="gotoDetail(5)"
      />
    </div>

    <!-- 5. 3·15金融消费者权益保护教育宣传活动 -->
    <div :class="[s.fullBlock]">
      <h3>3·15金融消费者权益保护教育宣传活动丨保障金融权益 助力美好生活</h3>
      <div :class="s.imageRow" style="--row-ratio: 16/9">
        <img
          :src="require('../../images/ic_publicity_detail6_1.jpg')"
          @click="previewImage(require('../../images/ic_publicity_detail6_1.jpg'))"
        />
        <img
          :src="require('../../images/ic_publicity_detail6_2.jpg')"
          @click="previewImage(require('../../images/ic_publicity_detail6_2.jpg'))"
        />
      </div>
    </div>

    <!-- 6. 金融产品查询平台 -->
    <div :class="[s.fullBlock]">
      <h3>金融产品查询平台</h3>
      <div :class="s.imageRow" style="--row-ratio: 16/9">
        <img
          :src="require('../../images/ic_publicity_detail7_1.jpg')"
          @click="previewImage(require('../../images/ic_publicity_detail7_1.jpg'))"
        />
      </div>
    </div>

    <!-- 7. 7.8全国保险公众宣传日 -->
    <div :class="[s.fullBlock]">
      <h3>7.8全国保险公众宣传日丨爱和责任 保险让生活更美好</h3>
      <div :class="s.imageRow" style="--row-ratio: 2/3">
        <img
          :src="require('../../images/ic_publicity_detail8_1.jpg')"
          @click="previewImage(require('../../images/ic_publicity_detail8_1.jpg'))"
        />
        <img
          :src="require('../../images/ic_publicity_detail8_2.jpg')"
          @click="previewImage(require('../../images/ic_publicity_detail8_2.jpg'))"
        />
        <img
          :src="require('../../images/ic_publicity_detail8_3.jpg')"
          @click="previewImage(require('../../images/ic_publicity_detail8_3.jpg'))"
        />
      </div>
    </div>

    <!-- 8. 防范非法金融活动宣传月活动 -->
    <div :class="[s.fullBlock]">
      <h3>防范非法金融活动宣传月活动丨守住钱袋子·护好幸福家</h3>
      <div :class="s.imageRow" style="--row-ratio: 1/2">
        <img
          :src="require('../../images/ic_publicity_detail9_1.jpg')"
          @click="previewImage(require('../../images/ic_publicity_detail9_1.jpg'))"
        />
        <img
          :src="require('../../images/ic_publicity_detail9_2.jpg')"
          @click="previewImage(require('../../images/ic_publicity_detail9_2.jpg'))"
        />
      </div>
      <div :class="s.imageRow" style="--row-ratio: 9/16">
        <img
          :src="require('../../images/ic_publicity_detail9_3.png')"
          @click="previewImage(require('../../images/ic_publicity_detail9_3.png'))"
        />
        <img
          :src="require('../../images/ic_publicity_detail9_4.png')"
          @click="previewImage(require('../../images/ic_publicity_detail9_4.png'))"
        />
        <img
          :src="require('../../images/ic_publicity_detail9_5.png')"
          @click="previewImage(require('../../images/ic_publicity_detail9_5.png'))"
        />
      </div>
      <div :class="s.imageRow" style="--row-ratio: 1/2">
        <img
          :src="require('../../images/ic_publicity_detail9_6.png')"
          @click="previewImage(require('../../images/ic_publicity_detail9_6.png'))"
        />
        <img
          :src="require('../../images/ic_publicity_detail9_7.png')"
          @click="previewImage(require('../../images/ic_publicity_detail9_7.png'))"
        />
        <img
          :src="require('../../images/ic_publicity_detail9_8.png')"
          @click="previewImage(require('../../images/ic_publicity_detail9_8.png'))"
        />
        <img
          :src="require('../../images/ic_publicity_detail9_9.png')"
          @click="previewImage(require('../../images/ic_publicity_detail9_9.png'))"
        />
      </div>
    </div>

    <!-- 大图预览遮罩 -->
    <div v-if="previewVisible" :class="s.previewOverlay" @click="closePreview">
      <img :src="previewSrc" :class="s.previewImg" />
    </div>
  </div>
</template>

<script>
import { sendDataTrack } from '@/utils';

export default {
  name: 'ContentPublicity',
  data() {
    return {
      previewVisible: false,
      previewSrc: ''
    };
  },
  computed: {
    s() {
      return this.$style;
    }
  },
  methods: {
    gotoDetail(type) {
      sendDataTrack('publicity', 'event', { type });
      this.$router.push(`/publicity/detail?type=${type}`);
    },
    previewImage(src) {
      this.previewSrc = src;
      this.previewVisible = true;
    },
    closePreview() {
      this.previewVisible = false;
      this.previewSrc = '';
    }
  }
};
</script>

<style scoped lang="less" module>
.contentPublicity {
  display: flex;
  flex-wrap: wrap;

  > div {
    width: 48px;
  }

  .slice {
    width: calc(50% - 24px);
    object-fit: cover;
    object-position: top;
  }

  .clickable {
    cursor: pointer;
  }

  .block {
    margin-top: 10px;

    h3 {
      font-size: 20px;
      color: #1669bc;
    }

    img {
      width: 100%;
      cursor: pointer;
    }
  }

  .fullBlock {
    width: 100%;
    margin-top: 30px;

    h3 {
      font-size: 20px;
      color: #1669bc;
      margin-bottom: 10px;
    }
  }

  .imageRow {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
    width: 100%;

    img {
      flex: 1;
      min-width: 0;
      aspect-ratio: var(--row-ratio, 16/9);
      object-fit: cover;
      object-position: top;
      cursor: pointer;
      border-radius: 4px;
    }
  }

  .previewOverlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    cursor: pointer;
  }

  .previewImg {
    max-width: 90vw;
    max-height: 90vh;
    object-fit: contain;
  }
}
</style>
